import { render, staticRenderFns } from "./DetailGroupExpansionPanel.vue?vue&type=template&id=3210dd62&"
import script from "./DetailGroupExpansionPanel.vue?vue&type=script&lang=js&"
export * from "./DetailGroupExpansionPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailGroupExpansionPanel.vue?vue&type=style&index=0&id=3210dd62&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports